import { render, staticRenderFns } from "./PreviewWithDecorations.vue?vue&type=template&id=6e0bec56&scoped=true&lang=pug&"
import script from "./PreviewWithDecorations.vue?vue&type=script&lang=js&"
export * from "./PreviewWithDecorations.vue?vue&type=script&lang=js&"
import style0 from "./PreviewWithDecorations.vue?vue&type=style&index=0&id=6e0bec56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0bec56",
  null
  
)

export default component.exports